var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.17 212.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #ffb612;\n      }\n\n      .cls-3 {\n        fill: #d37416;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        opacity: .73;\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-7 {\n        fill: #fff;\n        mix-blend-mode: overlay;\n        opacity: .3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.08,212.17C47.59,212.17,0,164.58,0,106.08S47.59,0,106.08,0s106.08,47.59,106.08,106.08-47.59,106.08-106.08,106.08ZM106.08,13.84C55.22,13.84,13.84,55.22,13.84,106.08s41.38,92.25,92.25,92.25,92.25-41.38,92.25-92.25S156.95,13.84,106.08,13.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.08,26.31c-15.03,0-29.09,4.16-41.09,11.39-23.18,13.96-38.68,39.36-38.68,68.38,0,34.52,21.93,63.91,52.61,75.02,8.48,3.07,17.62,4.75,27.16,4.75,44.06,0,79.77-35.72,79.77-79.77S150.14,26.31,106.08,26.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.2,121.56l5.66,5.66-13.01,13.01c-.45.45-1.19.45-1.64,0l-4.02-4.02c-.45-.45-.45-1.19,0-1.64l13.01-13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.64,131l15.79,15.79-13.01,13.01c-.45.45-1.19.45-1.64,0l-3.56-3.56c-.45-.45-.45-1.19,0-1.64l5.33-5.33-5.39-5.39-5.33,5.33c-.45.45-1.19.45-1.64,0l-3.56-3.56c-.45-.45-.45-1.19,0-1.64l13.01-13.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.36,
    y: 123.56,
    width: 8.98,
    height: 8.01,
    transform: "translate(-53.34 126.35) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.87,
    y: 130.91,
    width: 8.98,
    height: 22.33,
    transform: "translate(-59.35 140.87) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.11,63.47c-12.62,12.62-15.21,30.47-5.8,39.88,8.24,8.24,22.96,7.28,34.97-1.57l48.76,48.76c.45.45,1.18.46,1.64,0l7.5-7.5c.45-.45.45-1.19,0-1.64l-48.76-48.76c8.84-12,9.8-26.72,1.56-34.97-9.41-9.41-27.26-6.82-39.87,5.79ZM94.73,90.09c-7.09,7.09-17.13,8.55-22.42,3.26s-3.82-15.32,3.27-22.41c7.09-7.09,17.11-8.55,22.4-3.26,5.29,5.29,3.84,15.33-3.25,22.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.62,66.04c-5.29-5.29-15.32-3.83-22.4,3.26-.28.28-.53.57-.79.85,7.02-6.39,16.47-7.55,21.55-2.47,5.08,5.08,3.93,14.54-2.46,21.56.29-.26.57-.51.85-.79,7.09-7.09,8.54-17.12,3.25-22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.68,148.9l-48.76-48.76c-12.01,8.84-26.73,9.81-34.97,1.57-9.2-9.2-6.92-26.48,4.99-39.04-.28.27-.56.53-.84.81-12.62,12.62-15.21,30.47-5.8,39.88,8.24,8.24,22.96,7.28,34.97-1.57l48.76,48.76c.45.45,1.18.46,1.64,0l1.64-1.64c-.46.46-1.19.45-1.64,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.98,57.68c8.25,8.24,7.28,22.96-1.56,34.97l48.76,48.76c.45.45.45,1.19,0,1.64l-3.75,3.75-56.71-56.71c7.09-7.09,8.54-17.12,3.25-22.41-5.29-5.29-15.32-3.83-22.4,3.26l-7.47-7.47c12.61-12.61,30.46-15.2,39.87-5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.36,134.4l5.66,5.66-.17.17c-.45.45-1.19.45-1.64,0l-4.02-4.02c-.45-.45-.45-1.19,0-1.64l.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.63,144.02l.17-.17,5.2,5.2-.17.17c-.45.45-1.19.45-1.64,0l-3.56-3.56c-.45-.45-.45-1.19,0-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.22,154.61l.17-.17,5.2,5.2-.17.17c-.45.45-1.19.45-1.64,0l-3.56-3.56c-.45-.45-.45-1.19,0-1.64Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceKey);
export default __webpack_public_path__ + "static/media/SPACE_KEY.bba2e921e83423e3b6d5793ba94e7086.svg";
export { ForwardRef as ReactComponent };